import { useQuery } from "@tanstack/react-query";
import { Page, OwnScenario } from "@/model";
import scenarioRepository from "@/repository/scenarioRepository";


const getData = async (page?: number, size?: number, keyword?: string) => {
    const response = await scenarioRepository.findPage(page, size, keyword);
    return response.data;
};

export const usePaginatedScenarios = (page?: number, size?: number, keyword?: string) => {
    return useQuery<Page<OwnScenario>>({
        queryKey: ['page-scenarios', page, size, keyword],
        queryFn: () => getData(page, size, keyword)
    });
};
